import { useState } from "react";
export function useExcalidrawWrapper(excalidrawApi) {
    const [zoom, setZoom] = useState(1);
    async function notifyZoom() {
        await new Promise(r => requestAnimationFrame(() => r()));
        setZoom(excalidrawApi.getAppState().zoom.value);
    }
    return {
        zoom,
        notifyZoom
    };
}
